module.exports = {
    production: {   
        nextbestApi: 'https://ojtwn8ntff.execute-api.ap-southeast-1.amazonaws.com/api',
    },
    development: {
        nextbestApi: 'https://ojtwn8ntff.execute-api.ap-southeast-1.amazonaws.com/api'
    },


}
